module.exports = __webpack_public_path__ + "img/neshan.28af540b.png";